import * as React from 'react';

import { cn } from '@mint-lib/tw-utils';
import { cva, type VariantProps } from 'class-variance-authority';
import { Progress as ProgressPrimitive } from 'radix-ui';

const circularLoadingButtonVariants = cva(
  'animate-spin rounded-full border border-text-disabled',
  {
    variants: {
      variant: {
        contained: 'border-t-action-disabledBackground',
        outlined: 'border-t-transparent-main',
      },
      size: {
        large: 'size-5',
        medium: 'size-4.75',
        small: 'size-3.5',
      },
    },
  },
);
function ProgressRoot({
  className,
  ...props
}: React.ComponentProps<typeof ProgressPrimitive.Root>) {
  return (
    <ProgressPrimitive.Root
      data-slot="progress"
      className={cn(className)}
      {...props}
    />
  );
}

function ProgressIndicator({
  className,
  ...props
}: React.ComponentProps<typeof ProgressPrimitive.Indicator>) {
  return (
    <ProgressPrimitive.Indicator
      data-slot="progress-indicator"
      className={cn(className)}
      {...props}
    />
  );
}

function CircularLoadingButton({
  className,
  size,
  variant,

  ...props
}: React.ComponentProps<typeof ProgressPrimitive.Root> &
  VariantProps<typeof circularLoadingButtonVariants>) {
  return (
    <ProgressRoot data-slot="progress" className={cn(className)} {...props}>
      <ProgressIndicator
        data-slot="progress-indicator"
        className={cn(circularLoadingButtonVariants({ size, variant }))}
      />
    </ProgressRoot>
  );
}

export { CircularLoadingButton, ProgressRoot, ProgressIndicator };
